import React from 'react'
import PropTypes from 'prop-types'

import Price from './Price'
import './Saving.css'
import texts from '../../../common/texts.json'

const Saving = ({ basePrice, saving, priceRefClass, savingClass, showBeforePriceOnly }) => (
  <div className={`d-flex ${savingClass}`}>
    <span>{texts.PRODUCT_PRICES.REGULAR_TEXT}</span>
    <Price price={basePrice} className={priceRefClass} />
    {!showBeforePriceOnly && (
      <>
        <span>{texts.PRODUCT_PRICES.SAVING_TEXT}</span>
        <Price price={saving} />
      </>
    )}
  </div>
)

Saving.propTypes = {
  basePrice: PropTypes.number.isRequired,
  saving: PropTypes.number.isRequired,
  priceRefClass: PropTypes.string,
  savingClass: PropTypes.string,
  showBeforePriceOnly: PropTypes.bool,
}

Saving.defaultProps = {
  priceRefClass: 'saving__price__pdp',
  savingClass: 'pdp-mobile-reference-price',
  showBeforePriceOnly: false,
}

export default Saving
